import { render, staticRenderFns } from "./EcomFilterCategory.vue?vue&type=template&id=66e2d738&scoped=true"
import script from "./EcomFilterCategory.vue?vue&type=script&lang=js"
export * from "./EcomFilterCategory.vue?vue&type=script&lang=js"
import style0 from "./EcomFilterCategory.vue?vue&type=style&index=0&id=66e2d738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e2d738",
  null
  
)

export default component.exports